import { Card } from "primereact/card";
import { getCompany } from "../../../config/companyConfig";

const HelpSection = () => {
  const CONTACT_INFO = getCompany().contacts || [];
  return (
  <div className="flex flex-column gap-3">
    <Card title="¿Necesitas ayuda?">
      <p className="m-0 admin-text-sm mb-3" style={{ color: "var(--text-color-secondary)" }}>
        Contáctanos a través de nuestros canales de atención.
      </p>
      <div className="grid">
        {CONTACT_INFO.map((contact) => (
          <div key={contact.id} className="col-12 md:col-6">
            <Card>
              <div className="flex align-items-center gap-3 mb-2">
                <i className={`${contact.icon} text-xl`} style={{ color: "var(--primary-color)" }} />
                <strong className="admin-text-base">{contact.title}</strong>
              </div>
              <div className="flex flex-column gap-1">
                <span className="admin-text-sm">{contact.name}</span>
                <span className="admin-text-sm flex align-items-center gap-2">
                  <i className="pi pi-phone" style={{ fontSize: "0.75rem" }} />{contact.phone}
                </span>
                <span className="admin-text-sm flex align-items-center gap-2">
                  <i className="pi pi-envelope" style={{ fontSize: "0.75rem" }} />{contact.email}
                </span>
              </div>
            </Card>
          </div>
        ))}
      </div>
    </Card>
  </div>
  );
};

export default HelpSection;
